export const SET_COMMISSIONS = 'SET_COMMISSIONS';
export const SET_BANKING_DETAILS = 'SET_BANKING_DETAILS';
export const SET_SALES_REPS = 'SET_SALES_REPS';
